import React, { useEffect } from "react"

// The page's toast (SportyaToast tones): what a command did, with Undo while a Delete or a Withdraw waits (usePlannerCommands). A
// toast without Undo goes away by itself. `detail` follows the words: a waiting move's warnings at its new dates (Phase C1w).
export default function PlannerToast({ toast, detail, onUndo, onDismiss }) {
  useEffect(() => {
    if (!toast || toast.undo) return undefined
    const timer = setTimeout(onDismiss, 7000)
    return () => clearTimeout(timer)
  }, [toast, onDismiss])
  if (!toast) return null
  return <div role="status" className={`ep-toast ep-toast-${toast.tone}`}>
    <span>{toast.text}{detail && <span className="ep-toast-detail">{` ${detail}`}</span>}</span>
    {toast.undo && <button type="button" className="btn btn-light btn-sm" onClick={onUndo}>Undo</button>}
    <button type="button" className="ep-icon-button" aria-label="Dismiss" onClick={onDismiss}><i className="bx bx-x" aria-hidden="true" /></button>
  </div>
}
